import {useEffect,useState} from 'react';
import type {UsagePricing} from '@reados/contracts';
import {api} from '../api';
import {usageModelOptions} from '../ai-usage';

/** Pricing is platform metadata and does not start a user sandbox. */
export function useUsageModels(userId:string,enabled=true,revision=0){
 const [models,setModels]=useState<string[]>([]);
 useEffect(()=>{
  setModels([]);if(!enabled)return;
  const controller=new AbortController();let active=true;
  void api.usagePricing(controller.signal).then(value=>{if(active)setModels(usageModelOptions(value.models.map(model=>model.model),(value as UsagePricing&{modelIds?:string[]}).modelIds??[]));}).catch(()=>{});
  return()=>{active=false;controller.abort();};
 },[userId,enabled,revision]);
 return models;
}
